import script from "./EditDomainContactDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDomainContactDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./EditDomainContactDetailsModal.vue?vue&type=style&index=0&id=b2c99cf6&lang=css"

const __exports__ = script;

export default __exports__